import React, { useContext, useEffect, useState } from "react";
import NotificationItem from "../component/notification-item";
import SearchForm from "../component/search-form";
import { UserContext } from "../service/context";
import request from "../service/request";
import { socket } from "../service/socket";

const NotificationS = (props) => {
  const [notificationList, setNotificationList] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [filters, setFilters] = useState([]);
  const ctx = useContext(UserContext);

  useEffect(() => {
    socket.emit("join", { sender: ctx.user.id });
    (async () => {
      const result = await request(`/notification/${ctx.user.id}`, null, "GET", ctx.user.token);

      if (result.status) {
        setNotificationList(result.data);
        setNotifications(result.data);
      }
    })();
  }, []);

  useEffect(() => {
    socket.on("eventNotification", (data) => {
      setNotificationList([data, ...notificationList]);
      setNotifications([data, ...notificationList]);
    });
  });

  const handleSearch = (event) => {
    const { value } = event.target;
    if (value === "") {
      setNotifications(notificationList);
      return;
    }
    const result = notificationList.filter((item) => item.description.toLowerCase().includes(value.toLowerCase()));
    setNotifications(result);
  };

  const handleFilter = (item) => {
    if (filters.includes(item)) {
      setFilters((prev) => prev.filter((ele) => ele !== item));
      return;
    }
    setFilters([...filters, item]);
  };

  const handleClick = async (id) => {
    const payload = {
      id,
      user_id: ctx.user.id,
    };
    const result = await request(`/notification/singleNotification`, JSON.stringify(payload), "PATCH", ctx.user.token);

    if (result.status) {
      if (Array.isArray(result.data)) {
        setNotificationList(result.data);
        setNotifications(result.data);
      }
    }
  };

  const handleMultiRead = async () => {
    const ids = [];
    for (const item of notifications) {
      ids.push(item.id);
    }

    const payload = {
      ids,
    };
    const result = await request(`/notification/multiNotification`, JSON.stringify(payload), "PATCH", ctx.user.token);

    if (result.status) {
      if (Array.isArray(result.data)) {
        setNotificationList(result.data);
        setNotifications(result.data);
      }
    }
  };

  return (
    <div className="mb-[100px] mt-4 sm:mx-6 lg:mx-8">
      {/* Page header */}
      <header className="sm:flex sm:justify-between sm:items-center mb-3">
        {/* Left: Title */}
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">Notifications</h1>
        </div>

        {/* Search form */}
        <SearchForm placeholder="Search by category.." formClass="min-w-[50%]" onChange={(e) => handleSearch(e)} />
      </header>

      {notificationList.length === 0 && <div className="text-2xl text-gray-500 text-center mt-16">No notification found..</div>}

      {notificationList.length !== 0 && (
        <div>
          <div className="flex justify-end">
            <div className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white mt-5 cursor-pointer" onClick={handleMultiRead}>
              Mark as Read All
            </div>
          </div>

          <div className="flex flex-col space-y-10 sm:flex-row sm:space-x-6 sm:space-y-0 xl:flex-row xl:space-x-6 xl:space-y-0 mt-6">
            <div className="h-full bg-white shadow-lg rounded border border-slate-200 p-5 min-w-60">
              <div className="text-sm text-slate-800 font-semibold mb-3">Filter</div>
              <ul className="space-y-2">
                <li>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onChange={() => {
                        handleFilter("Activity Assignment");
                      }}
                    />
                    <span className="text-sm text-slate-600 font-medium ml-2">To Do Assignment</span>
                  </label>
                </li>
                <li>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onChange={() => {
                        handleFilter("Activity Performance");
                      }}
                    />
                    <span className="text-sm text-slate-600 font-medium ml-2">To Do Performance</span>
                  </label>
                </li>
                <li>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox"
                      onChange={() => {
                        handleFilter("Assignment");
                      }}
                    />
                    <span className="text-sm text-slate-600 font-medium ml-2">Assignment</span>
                  </label>
                </li>
              </ul>
            </div>
            <ul className="flex-auto mt-5 col-span-full xl:col-span-6 rounded space-y-2">{filters.length === 0 ? notifications.map((item, index) => <NotificationItem key={index} id={item.id} image={"/company-icon-05.svg"} title={item.title} link="/" details={item.description} date={item.createdAt} handleClick={handleClick} />) : notifications.map((item, index) => filters.includes(item.type) && <NotificationItem key={index} id={item.id} image={"/company-icon-05.svg"} title={item.title} link="/" details={item.description} date={item.createdAt} handleClick={handleClick} />)}</ul>
          </div>
        </div>
      )}
    </div>
  );
};

NotificationS.auth = { path: "/notifications", role: "super-admin" };
export default NotificationS;
